import {createImageObject} from '../utils';
import {
    placeHolder,
    suggestImg
} from '@/views/V2/image/cutout/utils/constants.js';

export default {
    namespaced: true,
    state: {
      title: '智能抠图',
      uploadImg: [],
      displayImg: [],
      recordImg: [],
      editLoading: false,
      toolBarLoading: false,
      suggestImg,
      placeHolder,
      historyParams: {
        pageNo: 1,
        pageSize: 10,
        taskType: [12]
      },
      pageLoadingStatus: {
        show: false,
        title: ''
      }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        CHANGE_UPLOAD_IMG(state, data) {
            state.uploadImg = data;
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let update of updates) {
                state[update.key] = update.value;
            }
        }
    },
    actions: {
        changeUploadImg({commit}, data) {
            commit('CHANGE_UPLOAD_IMG', data);
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    const recordList = i.records;
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片上传 获取主体
        async handleImgChoose({commit, state}, {e}) {
            const uploadImg = e.map(item => ({
                url: item.url,
                prompt: '',
                width: item.width,
                height: item.height
            }));
            const allUploadImg = state.uploadImg.concat(uploadImg);
            commit('CHANGE_UPLOAD_IMG', allUploadImg);
        },
        // 抠图按钮提交
        async handleCutSubmit({commit, state}, {model}) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const baseDisplayImg = state.uploadImg.map((_, index) => createImageObject({recordId: index}));
                commit('CHANGE_DISPLAY_IMG', baseDisplayImg);

                const params = state.uploadImg.map(i => ({
                    cropMain: 1,
                    prompt: i.prompt,
                    subjectImage: i.url,
                    width: `${i.width}`,
                    height: `${i.height}`
                }));
                const data = await model.imageCreate.cutoutImageV2({
                    cutItem: params,
                    saveType: true,
                    hasParam: false
                });
                const displayImg = data.map(i => createImageObject({
                    specialOrgUrl: i.specialOrgUrl,
                    url: i.subjectImage,
                    taskId: i.taskId,
                    recordId: i.recordId,
                    width: i.width,
                    height: i.height,
                    ext: i.ext
                }));

                commit('UPDATE_MULTIPLE_STATES', [{
                    key: 'displayImg',
                    value: displayImg
                }]);
                return displayImg;
            }
            catch (err) {
                commit('UPDATE_MULTIPLE_STATES', [{
                    key: 'displayImg',
                    value: []
                }]);
                throw err;
            }
            finally {
                commit('UPDATE_COMMON_STATE', {
                    key: 'toolBarLoading',
                    value: false
                });
            }
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        }
    },
    getters: {
    }
  };
